import React from 'react'

import { isEmpty } from 'lodash'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Box, Chip, Hidden, Paper, TablePagination } from '@material-ui/core'

import { LoadingFeedback, NoData2 } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import { ActionButtons } from './components'

import * as service from 'service'
import helpers from 'helpers'
import constants from 'constants/index'

import useFetch from 'hooks/useFetch'
import usePagination from 'hooks/usePagination'

import useStyles from './styles'

const PmcTable = () => {
  const classes = useStyles()

  const { STATUSES } = constants.monitoringManagementPmc

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const { response, isLoading, refresh } = useFetch(
    service.dponet.monitoringManagementPmc.list,
    { perPage, page },
    [perPage, page],
  )

  const monitoringManagementPmcs = response?.data?.monitoringManagementPmcs

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <Paper>
        {!isEmpty(monitoringManagementPmcs) ? (
          <>
            <Box width="100%">
              <PerfectScrollbar
                options={{ wheelPropagation: false, useBothWheelAxes: true }}
              >
                <Table size="small" noWrap>
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>Título</TableCell>
                      <TableCell>Responsável</TableCell>
                      <TableCell>Departamento</TableCell>
                      <TableCell>Data de conclusão</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell align="right">Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {monitoringManagementPmcs?.map(
                      (monitoringManagementPmc) => (
                        <TableRow key={monitoringManagementPmc?.id}>
                          <TableCell>{monitoringManagementPmc?.id}</TableCell>
                          <TableCell>
                            {monitoringManagementPmc?.title}
                          </TableCell>
                          <TableCell>
                            {monitoringManagementPmc?.user?.name}
                          </TableCell>
                          <TableCell>
                            {monitoringManagementPmc?.department?.name}
                          </TableCell>
                          <TableCell>
                            {helpers.formatters.date(
                              monitoringManagementPmc?.endDatePlanned,
                            ) || '-'}
                          </TableCell>
                          <TableCell>
                            <Chip
                              size="small"
                              className={
                                classes[monitoringManagementPmc?.status]
                              }
                              label={STATUSES[monitoringManagementPmc?.status]}
                            />
                          </TableCell>
                          <TableCell align="right">
                            <ActionButtons
                              monitoringManagementPmc={monitoringManagementPmc}
                              refresh={refresh}
                            />
                          </TableCell>
                        </TableRow>
                      ),
                    )}
                  </TableBody>
                </Table>
              </PerfectScrollbar>
            </Box>
            <TablePagination
              component="div"
              count={response?.data?.meta?.totalCount || 0}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              page={page - 1}
              rowsPerPage={perPage}
              rowsPerPageOptions={[5, 10, 25, 100]}
              labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
              nextIconButtonProps={{ size: 'small' }}
              backIconButtonProps={{ size: 'small' }}
            />
          </>
        ) : (
          !isLoading && (
            <NoData2 title="Nenhum Plano de melhoria contínua encontrado." />
          )
        )}
      </Paper>
    </>
  )
}

export default PmcTable
